import React from 'react';
import { Map } from 'immutable';
import Dropdown from 'shared/components/menus/dropDown';

class FontSizeDropDown extends React.Component {
  render() {
    return (
      <div className="word-export-hero-font-size-dropdown">
        <Dropdown config={this._getConfig()} />
      </div>
    );
  }

  _getConfig() {
    let { activeItem } = this.props; // eslint-disable-line react/prop-types

    return Map({
      noCaret: false,
      icon: null,
      content: activeItem,
      items: this._getOrderedMapOfItems(),
    });
  }

  _getOrderedMapOfItems() {
    let { items, onChange } = this.props;

    return items.map((val, key) => {
      return Map({
        type: 'link',
        content: key,
        onClick: () => onChange(key),
      });
    });
  }

  // eslint-disable-next-line no-unused-vars
  _handleSelection(key, size) {
    this.props.onChange(key);
  }
}

FontSizeDropDown.propTypes = {
  active: React.PropTypes.string.isRequired,
  items: React.PropTypes.object.isRequired,
  onChange: React.PropTypes.func.isRequired,
};

FontSizeDropDown.defaultProps = {
  active: 'Default',
};

export default FontSizeDropDown;
